import { CAT_EVENTS } from '@/app/utils/Collections';
import { FT_LIST, FT_DATE, FT_AUTOCOMPLETE, FT_SINGLE, FT_CHECKBOX } from '../FilterTypes';
import {
  loadEventFileGroups,
  loadEventThemes,
  loadLocations,
  loadEventTypes,
  loadCategories,
  searchCompany,
  searchProduct,
} from './loaders';

const groups = {
  general: {
    name: 'General',
    groupOrderIndex: 0,
  },
  date: {
    name: 'Date',
    groupOrderIndex: 1,
  },
  business: {
    name: 'Business',
    groupOrderIndex: 2,
  },
};

export default {
  category: CAT_EVENTS,
  filters: [
    {
      id: 'files.fileGroup',
      label: 'Show events with files',
      type: FT_LIST,
      group: groups.general,
      getListItems: loadEventFileGroups,
      defaultValue: () => [18],
    },
    {
      id: 'visitation',
      label: 'Wingle visit',
      type: FT_CHECKBOX,
      hint: '',
      group: groups.general,
      defaultValue: () => true,
    },
    {
      id: 'themes',
      label: 'Themes',
      type: FT_LIST,
      group: groups.general,
      getListItems: loadEventThemes,
    },
    {
      id: 'country',
      label: 'Country',
      type: FT_AUTOCOMPLETE,
      group: groups.general,
      fieldConf: {
        searcher: loadLocations,
      },
    },
    {
      id: 'city',
      label: 'City',
      type: FT_SINGLE,
      group: groups.general,
    },
    {
      id: 'types',
      label: 'Types',
      type: FT_LIST,
      group: groups.general,
      getListItems: loadEventTypes,
    },
    {
      id: 'startedOn',
      type: FT_DATE,
      label: 'Start date',
      group: groups.date,
    },
    {
      id: 'finishedOn',
      type: FT_DATE,
      label: 'Finish date',
      group: groups.date,
    },
    {
      id: 'categories',
      label: 'Categories',
      type: FT_LIST,
      group: groups.general,
      getListItems: () => loadCategories(),
    },
    {
      id: 'companies',
      label: 'Companies',
      type: FT_AUTOCOMPLETE,
      group: groups.business,
      fieldConf: {
        searcher: searchCompany,
      },
    },
    {
      id: 'products',
      label: 'Products',
      type: FT_AUTOCOMPLETE,
      group: groups.business,
      fieldConf: {
        searcher: searchProduct,
      },
    },
  ],
  searchBarProp: 'complex_name',
  useStrictSearch: false,
};
